module.exports = __webpack_public_path__ + "img/deyu_commend_img.0c534771.png";